import './App.css';
import React, { Component } from "react";
// import Body from './pages/Body.js';
import Welcome from './pages/Welcome.js';
import { Amplify } from 'aws-amplify';
import config from './amplifyconfiguration.json';
Amplify.configure(config);

class App extends Component {
  constructor() {
    super();
    this.state = {
      width: window.innerWidth,
      loading: true,
    };
  }

  async componentDidMount() {
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  render () {
    const { width } = this.state;
    const isMobile = width <= 500;
    const className = isMobile ? "AppMobile" : "App";

      return (
        <div className={className}>
          <Welcome isMobile={isMobile} />
        </div>
      );
    }
  }

export default App;